module.exports = __webpack_public_path__ + "static/media/error.83c1e9d1.svg";